<script setup lang="ts">
import { computed } from "vue";
import { UiLinkButton } from "@shopexperts/shared";
import type { UiIconProps } from "@shopexperts/shared";

const props = withDefaults(defineProps<{
    label: string;
    icon: UiIconProps["name"];
    tone?: "default" | "primary" | "warn" | "danger";
    disabled?: boolean;
}>(), {
    tone: "default",
});

defineEmits<{
    (e: "click"): void;
}>();

const toneClass = computed(() => {
    const tone = (() => {
        switch (props.tone) {
            case "primary":
                return "hover:text-se-primary";
            case "warn":
                return "hover:text-amber-700";
            case "danger":
                return "hover:text-red-600";
            default:
                return "hover:text-se-gray-700";
        }
    })();

    // `disabled` is forwarded to the native button, so this only dims it.
    return `${tone} !mx-0 shrink-0 !px-3 ${props.disabled ? "opacity-50" : ""}`;
});
</script>

<template>
    <UiLinkButton
        variant="ghost"
        hover-decoration="underline"
        text-variant="p-small"
        :label="label"
        :icon="icon"
        :disabled="disabled"
        :class="toneClass"
        @click="$emit('click')"
    />
</template>
